// frontend/init/index.js

import './index.css';
import './import_resource_user_views';
import './set-initial-body-classes';
import './save-local-storage-to-cookies';
import './turbolinks-cleanup';
